'use strict';

const Backbone = require('backbone');

const GroupPermission = Backbone.Model.extend({
    defaults: {
        permit: false
    },
    isPermitted: function(context) {
        if(context.getGroupRole().isAdmin()) {
            return true;
        }

        return this.get('permit');
    }
}, {
    type: null
});

const GroupEditPermission = GroupPermission.extend({

}, {
    type: 'group:edit'
});

const GroupMembersViewPermission = GroupPermission.extend({

}, {
    type: 'group:members:view'
});

const ProjectCreatePermission = GroupPermission.extend({

}, {
    type: 'project:create'
});

const NotParticipatedProjectViewPermission = GroupPermission.extend({

}, {
    type: 'not:participated:project:view'
});

module.exports = {
    GroupPermissions: [
        GroupEditPermission,
        ProjectCreatePermission,
        NotParticipatedProjectViewPermission,
        GroupMembersViewPermission
    ],
    GroupEditPermission: GroupEditPermission,
    GroupMembersViewPermission: GroupMembersViewPermission,
    ProjectCreatePermission: ProjectCreatePermission,
    NotParticipatedProjectViewPermission: NotParticipatedProjectViewPermission
};



// WEBPACK FOOTER //
// ./common/domain/entity/group-permission.js